module.exports = __webpack_public_path__ + "static/media/logo.c7df957c.svg";